<template>
    <Layout>
        <PageHeader title="Edit SOP" :items="[]" />
        <b-row>
            <b-col cols="12">
                <div class="card" style="border: 1px solid var(--ck-color-base-border);">
                    <div class="card-body">
                        <b-row class="mb-2">
                            <b-col cols="5">
                                <div class="form-group row mb-3">
                                    <label class="col-md-3 col-form-label" for="name">User name</label>
                                    <div class="col-md-9">
                                        <input type="text" class="form-control" value="Themesbrand"/>
                                    </div>
                                </div>
                            </b-col>
                            <b-col cols="5">
                                <div class="form-group row mb-3">
                                    <label class="col-md-3 col-form-label" for="name">User name</label>
                                    <div class="col-md-9">
                                        <input type="text" class="form-control" value="Themesbrand"/>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="5">
                                <div class="form-group row mb-3">
                                    <label class="col-md-3 col-form-label" for="name">User name</label>
                                    <div class="col-md-9">
                                        <input type="text" class="form-control" value="Themesbrand"/>
                                    </div>
                                </div>
                            </b-col>
                            <b-col cols="5">
                                <div class="form-group row mb-3">
                                    <label class="col-md-3 col-form-label" for="name">User name</label>
                                    <div class="col-md-9">
                                        <input type="text" class="form-control" value="Themesbrand"/>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12">
                <div class="document-editor">
                    <div class="document-editor__toolbar"></div>
                    <div class="document-editor__editable-container">
                            <div class="document-editor__editable">
                                <p>{{sop_body}}</p>
                            </div>
                    </div>
                </div>
            </b-col>
        </b-row>
    </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
//import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document"

export default {
    data:() => ({
        sop_body: '',
    }),
    computed:{},
    components:{
        Layout,
        PageHeader,
    },
    methods:{
        /*initEditor(){
            DecoupledEditor
            .create( document.querySelector( '.document-editor__editable' ),{
                table: {
                    contentToolbar: [
                        'tableColumn', 'tableRow', 'mergeTableCells',
                        'tableProperties', 'tableCellProperties'
                    ],
                    tableProperties: {},

                    tableCellProperties: {}
                }
            })
            .then( editor => {
                const toolbarContainer = document.querySelector( '.document-editor__toolbar' );
                toolbarContainer.appendChild( editor.ui.view.toolbar.element );
                window.editor = editor;
            })
            .catch( err => {
                console.error( err );
            });
        }*/
    },
    mounted(){
        //this.initEditor();
    },
}
</script>

